module.exports = __webpack_public_path__ + "img/create_brief_illustration.eaebe0f5.svg";